module.exports = require("apollo-cache-inmemory");